import React from 'react';
import { climateLogo } from '../../../../assets/images/images';

interface MessageContainerProps {
    isFromJob?: boolean;
    children: React.ReactNode;
}

const MessageContainer: React.FC<MessageContainerProps> = ({ isFromJob = false, children }) => {
    return (
        <div className="incoming_msg">
            <div className={`incoming_msg_img ${isFromJob ? 'd-none' : ''}`}>
                <img src={climateLogo} alt="sunil" />{' '}
            </div>
            <div className="received_msg">
                <div className="received_withd_msg">
                    {children}
                </div>
            </div>
        </div>
    );
};

export default MessageContainer;



